import { useSelector } from "react-redux";
import { selectCurrentLicenceId } from "../../../store/licenceStore/licenceSelectors";
import FileListContainer from "../../FileListContainer";
import { CheckPermission } from "../../../requests/CheckPermission";
import { PERMISSIONS } from "../../../store/userStore/permissions.enum";


const LicenceRightPanel = () => {
  const currentLicenceId = useSelector(selectCurrentLicenceId);

  return (
    <CheckPermission
      permissionName={PERMISSIONS.LICENCE_MANAGEMENT_ACTIONS}
      noPermissionComponent={(
        <FileListContainer
          licenceId={currentLicenceId}
        />
      )}
    >
      <FileListContainer
        uploadAllowed
        showDelete
        licenceId={currentLicenceId}
      />
    </CheckPermission>
  )
}

export default LicenceRightPanel;